import {
  FormFieldBaseProps,
  Select,
  SelectChangeEvent,
  SelectProps,
  SelectRef,
  StructuredOption
} from '@athena/forge';
import WidgetFormField, { WidgetFormFieldProps } from './WidgetFormField';
import { RefAttributes } from 'react';

export type DropDownListProps = Omit<
  WidgetFormFieldProps<Omit<SelectProps, 'options'>> & {
    inputFieldContainer: JQuery;
    options?: ReadonlyArray<StructuredOption>;
    defaultValue?: StructuredOption;
  },
  'onChange' | 'labelText' | 'type' | 'onClick' | 'onBlur' | 'description' | 'id' | 'value' | 'inputAs'
>;
export default function DropDownList({
  inputFieldContainer,
  defaultValue,
  options,
  ...passthroughProps
}: DropDownListProps) {
  const dropDownList = inputFieldContainer.find('select');
  const label = inputFieldContainer.find('label');
  const finalOptions: ReadonlyArray<StructuredOption> =
    options ??
    inputFieldContainer
      .find('option')
      .map((_: any, element: { value: any; text: any }) => ({ value: element.value, label: element.text }))
      .toArray();
  const finalDefaultValue =
    finalOptions?.find((entry: StructuredOption) => dropDownList.val() === entry.value) ?? defaultValue;
  if (finalDefaultValue && dropDownList.val() !== finalDefaultValue.value) {
    //Set it back to Okta dropdown if the default value is different
    dropDownList.val(finalDefaultValue.value);
  }
  return (
    <WidgetFormField
      {...passthroughProps as Omit<SelectProps<boolean> & RefAttributes<SelectRef<boolean>>, keyof FormFieldBaseProps>}
      id={`athena-${dropDownList.attr('name')}`}
      labelText={label.text()}
      defaultValue={[ finalDefaultValue as StructuredOption ]}
      options={finalOptions}
      onChange={(event: SelectChangeEvent<boolean>) => {
        if (event.target.value) {
          if ('value' in event.target.value) {
            dropDownList.val(event.target.value.value);
          }
          else {
            dropDownList.val(event.target.value[0].value);
          }
          dropDownList.trigger('change');
        }
      }}
      inputAs={Select}
      closeMenuOnSelect
      required
    />
  );
}
